import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { ColAction, ListData, PtEntity, UserResourceField } from '@pt/pt-models';
import { TranslateService } from '@ngx-translate/core';
import { CellClickedEvent, ColDef, GridOptions } from 'ag-grid-community';
import { AgGridTableWrapper } from '../../../utils';
import { ag_grid_frameworkComponents } from '../../../pt-shared.constant';
import { UserResource } from 'it/primatoo/openapi/api/org/schemas/userresource/UserResource';
import { PermissionManager } from '@pt/pt-core';

@Component({
  selector: 'pt-select-user-resource-table',
  template: `
    <ag-grid-angular
      *ngIf='gridOptions()'
      class='ag-theme-balham w-100'
      [statusBar]="statusBar"
      [loadingOverlayComponent]="loadingOverlayComponent"
      [loadingOverlayComponentParams]="loadingOverlayComponentParams"
      (filterChanged)="onFilterChanged()"
      [gridOptions]='gridOptions()'
      (columnVisible)='onChangeColumnsVisible($event?.columns)'
      (selectionChanged)='checkBoxChanged()'
      (cellClicked)='cellClicked($event)'
      (gridReady)='onGridReady($event)'
    ></ag-grid-angular>
  `,
  styles: [`
    ag-grid-angular {
      height: 322px;
    }
  `]
})
export class SelectUserResourceTableComponent extends AgGridTableWrapper<UserResource> implements OnChanges {
  @Input() data: ListData<UserResource> = null;
  @Input() selectedUserResource: UserResource;
  @Output() userResourceSelected = new EventEmitter<UserResource>();

  entity: PtEntity = 'userResources';

  constructor(private translateService: TranslateService, public permissionManager: PermissionManager) {
    super(translateService, permissionManager);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.onChangeData(changes.data.currentValue);
    }
  }

  cellClicked(row: CellClickedEvent) {
    row.node.setSelected(true);
  }

  createColumnDefs(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      field: UserResourceField.name,
      lockVisible: true,
      flex: 1,
      resizable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      checkboxSelection: true
    });
    colDef.push({
      field: UserResourceField.surname,
      flex: 1,
      resizable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true
    });
    colDef.push({
      field: UserResourceField.email,
      flex: 1,
      resizable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true
    });
    colDef.push({
      field: UserResourceField.createdAt,
      flex: 1,
      resizable: true,
      cellRenderer: 'dateFormatterRenderer',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true
    });

    return colDef;
  }

  createGridOptions(columnDefs: ColDef[], rowData: UserResource[]): GridOptions {
    return {
      animateRows: false,
      pagination: false,
      rowSelection: 'single',
      rowHeight: 30,
      floatingFiltersHeight: 30,
      defaultColDef: {
        cellStyle: {'line-height': '30px', 'font-size': '12px'}
      },
      rowData,
      columnDefs,
      components: ag_grid_frameworkComponents
    } as GridOptions;
  }

  clickActions(action: ColAction, row: UserResource) {
    return;
  }

  colActionsTemplate(): TemplateRef<unknown> {
    return null;
  }

  checkBoxChanged() {
    this.selectedUserResource = this.gridApi.getSelectedRows()[0];
    this.userResourceSelected.emit(this.selectedUserResource);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    //todo capire cosa fa e se serve @Simone
    if (this.selectedUserResource) {
      this.gridApi.forEachNode(node => {
        if (node.data.id === this.selectedUserResource.id) {
          node.setSelected(true, true);
          this.gridApi.ensureIndexVisible(node.rowIndex);
        }
      });
    }
  }
}
